import { Helmet } from "react-helmet"

import Sidebar from "components/partials/sidebar"
import Topbar from "components/partials/topbar"
import React, { useEffect, useLayoutEffect, useState } from "react"
import { useLocation, useBeforeUnload, useOutlet, useOutletContext, Outlet, useNavigate, useNavigation, useNavigationType, Link } from "react-router-dom"
import { usePage } from "contexts/page-context"
import { useMatch } from "react-router-dom"
import nProgress from "nprogress"
import { AnimatePresence, motion, useAnimationControls } from "framer-motion"
import { Transition } from "components"
import { findRoute } from "helpers/route-helper"

const defaultVariant = {
    initial: { opacity: 0 },
    animate: {
        opacity: 1,
        transition: {
            duration: .5,
            type: 'tween'
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: .5,
            type: 'tween'
        }
    },
}

const slideVariant = {
    initial: {
        // opacity: 0,
        x: '-110%'
    },
    animate: {
        // opacity: 1,
        x: 0,
        transition: {
            type: 'spring',
            damping: 20
        }
    },
    exit: {
        // opacity: 0,
        x: '-110%',
        transition: {
            type: 'spring',
            damping: 20
        }
    },
}

const reversedSlideVariant = {
    initial: {
        // opacity: 0,
        x: '110%'
    },
    animate: {
        // opacity: 1,
        x: 0,
        transition: {
            type: 'spring',
            damping: 20
        }
    },
    exit: {
        // opacity: 0,
        x: '110%',
        transition: {
            type: 'spring',
            damping: 20
        }
    },
}

const AppLayout = () => {
    const page = useAnimationControls()
    const location = useLocation()
    const route = findRoute(location.pathname)

    const [title, setTitle] = useState(route?.title)
    const [transition, setTransition] = useState({ type: 'slide', reverse: false })

    const [isSidebarOpen, setIsSidebarOpen] = useState(false)

    const navigate = useNavigationType()

    const [prevRouteState, setPrevRouteState] = useState({})

    useEffect(() => {
        const getPrevRouteState = async () => {
            setPrevRouteState({
                back: location.state?.back,
                transition: location.state?.transition
            })
        }

        getPrevRouteState()
    }, [location.pathname])

    // useLayoutEffect(() => {
    //     document.documentElement.scrollTo(0, 0)
    // }, [location.pathname])

    const AnimatedOutlet = () => {
        // const o = useOutlet()
        // const [outlet] = useState(o)

        // return <>{outlet}</>

        const [outlet] = useState(useOutlet({ title, setTitle, transition, setTransition }))

        return outlet
    }

    useEffect(() => {
        setTitle(route?.title)
    }, [location])

    useEffect(() => {
        if (isSidebarOpen) {
            page.start({
                x: '16rem'
            })
        } else {
            page.start({
                x: 0
            })
        }
    }, [isSidebarOpen])

    const variant = transition?.type === 'slide' ? (transition?.reverse ? reversedSlideVariant : slideVariant) : defaultVariant

    return (
        <>
            <Helmet>
                <title>{`${title} – ${process.env.REACT_APP_NAME}`}</title>
            </Helmet>
            <div className="flex overflow-hidden">
                <Sidebar isSidebarOpen={isSidebarOpen} />
                <motion.div onClick={isSidebarOpen ? () => setIsSidebarOpen(false) : () => { }} animate={page} transition={{ type: "spring", damping: 20 }} className="w-full max-h-screen min-h-screen overflow-x-hidden overflow-y-auto bg-white border-8 inset-2 border-neutral-100 rounded-2xl">
                    <Topbar title={title} isSidebarOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
                    {/* {JSON.stringify(navigate)}
                    {JSON.stringify(location.pathname)}
                    {JSON.stringify(prevRouteState)} */}
                    <div className="m-4 space-y-16 lg:m-8">
                        <div>
                            {prevRouteState?.back ? (
                                <>
                                    <button key={prevRouteState?.back}>
                                        <Link to={location.state?.from} state={{ back: null, from: location.pathname, transition: 'slide' }} className="transition hover:opacity-50">
                                            <motion.h3 layout transition={{ type: "spring", damping: 20 }} layoutId={prevRouteState?.back} className="text-sm">{prevRouteState?.back}</motion.h3>
                                        </Link>
                                    </button>
                                    <motion.div
                                        key={location.pathname}
                                        variants={variant}
                                        initial="initial"
                                        animate="animate"
                                        exit="exit"
                                        className="relative">
                                        <h1 key={location.pathname} className="text-3xl font-medium">
                                            {title}
                                        </h1>
                                    </motion.div>
                                </>
                            ) : (
                                <div>
                                    <button className="cursor-default">
                                        <motion.h1 layout transition={{ type: "spring", damping: 20 }} layoutId={title} className="text-3xl font-medium">
                                            {title}
                                        </motion.h1>
                                    </button>
                                </div>
                            )}
                        </div>
                        {/* {JSON.stringify(prevRouteState)} */}
                        <div className="relative">
                            <AnimatePresence mode="sync" initial={false}>
                                <motion.div
                                    key={location.pathname}
                                    variants={variant}
                                    initial="initial"
                                    animate="animate"
                                    exit="exit"
                                    className="absolute inset-0">
                                    {/* <div className="absolute inset-0"> */}
                                    <AnimatedOutlet />
                                    {/* </div> */}
                                </motion.div>
                            </AnimatePresence>
                        </div>
                    </div>
                </motion.div >
            </div >
        </>
    )
}

export default AppLayout